"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GatewayViewModel = void 0;
const FlowNodeViewModel_1 = require("../FlowNodeViewModel");
class GatewayViewModel extends FlowNodeViewModel_1.FlowNodeViewModel {
}
exports.GatewayViewModel = GatewayViewModel;
//# sourceMappingURL=GatewayBaseViewModel.js.map